import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SerwisMapowyComponent } from './serwis-mapowy/strony/serwis-mapowy/serwis-mapowy.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonsModule } from "./commons/commons.module";
import { TranslateModule } from '@ngx-translate/core';
import { TlumaczeiaModulMapowyAdapter, DomyslnyTlumaczeniaModulMapowyAdapter } from '../core/providers/tlumaczenia-modul-mapowy-adapter';
import { IkonaSvgDirective } from './commons/directives/ikona-svg.directive';
import { RouterModule } from '@angular/router';
import { PasekStanuComponent } from './serwis-mapowy/komponenty/dolna-belka/pasek-stanu/pasek-stanu.component';
import { TylkoMobileDirective } from './mm-core/responsywnosc/dyrektywy/tylko-mobile.directive';
import { TylkoDesktopDirective } from './mm-core/responsywnosc/dyrektywy/tylko-desktop.directive';
import { WidokMapyNarzedziaSekcjaComponent } from './serwis-mapowy/komponenty/mapa/widok-mapy-narzedzia-sekcja/widok-mapy-narzedzia-sekcja.component';
import { WidokMapyComponent } from './serwis-mapowy/komponenty/mapa/widok-mapy/widok-mapy.component';
import { InformacjeOObiekcieComponent } from './serwis-mapowy/komponenty/mapa/informacje-o-obiekcie/informacje-o-obiekcie.component';
import { DomyslnaKonfiguracjaModulMapowyAdapter, KonfiguracjaModulMapowyAdapter } from './mm-core/providers/konfiguracja-adapter';
import { GrupyWarstwPodkladowychModulMapowyAdapter, DomyslneGrupyWarstwPodkladowychAdapter } from './mm-core/providers/grupy-warstw-podkladowych-adapter';
import { OracleMapsModule } from './oracle-maps/oracle-maps.module';
import { DomyslnyDostepneWarstwyAdapter, DostepneWarstwyModulMapowyAdapter } from './mm-core/providers/dostepne-warstwy-adapter';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { KomunikatyModulMapowyAdapter, DomyslneKomunikatyModulMapowyAdapter } from '../core/adaptery/komunikaty-adapter';
import { KontaktZAdministratoremModulMapowyAdapter, DomyslnyKontaktZAdministratoremAdapter } from '../core/adaptery/kontakt-z-administratorem-adapter';
import { MapyModulMapowyAdapter, DomyslneMapyModulMapowyAdapter } from './mm-core/providers/mapy-adapter';
import { PasekCzasuModulMapowyAdapter, DomyslnyPasekCzasuModulMapowyAdapter } from './mm-core/providers/pasek-czasu-adapter';
import { PobieranieDanychModulMapowyAdapter } from './mm-core/providers/pobieranie-danych-adapter';
import { PomocModulMapowyAdapter, DomyslnaPomocModulMapowyAdapter } from './mm-core/providers/pomoc-adapter';
import { WyszukiwarkaModulMapowyAdapter, DomyslnyWszukiwarkaAdapter } from './mm-core/providers/wyszukiwarka-adapter';
import { KontrolerWarstwPodkladowychComponent } from './serwis-mapowy/komponenty/mapa/kontroler-warstw-podkladowych/kontroler-warstw-podkladowych.component';
import { WyborTlumaczeniaPipe } from './serwis-mapowy/pipes/wybor-tlumaczenia.pipe';
import { PrzewijanyKomponentComponent } from './commons/komponenty/przewijany-komponent/przewijany-komponent.component';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import { SterowanieMapyComponent } from './serwis-mapowy/komponenty/mapa/sterowanie-mapy/sterowanie-mapy.component';
import { MapaSpinnerComponent } from './serwis-mapowy/komponenty/mapa/mapa-spinner/mapa-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { KlikalnoscNaMapieComponent } from './serwis-mapowy/komponenty/mapa/klikalnosc-na-mapie/klikalnosc-na-mapie.component';
import { RerenderDirective } from './commons/directives/rerender.directive';
import { KontrolerFunkcjiDodatkowychComponent } from './serwis-mapowy/komponenty/gorna-belka/kontroler-funkcji-dodatkowych/kontroler-funkcji-dodatkowych.component';
import { MobilnyKontrolerNarzedziComponent } from './serwis-mapowy/komponenty/gorna-belka/mobilny-kontroler-narzedzi/mobilny-kontroler-narzedzi.component';
import { BocznaBelkaKontenerComponent } from './serwis-mapowy/komponenty/boczna-belka/boczna-belka-kontener/boczna-belka-kontener.component';
import { PrzyciskIkonaComponent } from './commons/komponenty/przycisk-ikona/przycisk-ikona.component';
import { StoreModule } from '@ngrx/store';
import { interfejsUzytkowikaReducer } from './stan/interfejs-uzytkownika/interfejs-uzytkownika.reducer';
import { OsPrzegladanieComponent } from './serwis-mapowy/komponenty/boczna-belka/os-przegladanie/os-przegladanie.component';
import { OsTematyComponent } from './serwis-mapowy/komponenty/boczna-belka/os-tematy/os-tematy.component';
import { OsSzlakiComponent } from './serwis-mapowy/komponenty/boczna-belka/os-szlaki/os-szlaki.component';
import { OsTagiComponent } from './serwis-mapowy/komponenty/boczna-belka/os-tagi/os-tagi.component';
import { OsInfoComponent } from './serwis-mapowy/komponenty/boczna-belka/os-info/os-info.component';
import { lewyPanelWidokReducer } from './stan/lewy-panel-widok/lewy-panel-widok.reducer';
import { BelkaKartaMapyComponent } from './serwis-mapowy/komponenty/boczna-belka/belka-karta-mapy/belka-karta-mapy.component';
import { PrzyciskOkraglyComponent } from './commons/komponenty/przycisk-okragly/przycisk-okragly.component';
import { OsMapyPlanyComponent } from './serwis-mapowy/komponenty/boczna-belka/os-mapy-plany/os-mapy-plany.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { ObiektOpisComponent } from './serwis-mapowy/komponenty/mapa/obiekt-opis/obiekt-opis.component';
import { LokalizacjaOpisComponent } from './serwis-mapowy/komponenty/mapa/lokalizacja-opis/lokalizacja-opis.component';
import { ObiektZalacznikiIZdjeciaComponent } from './serwis-mapowy/komponenty/mapa/obiekt-zalaczniki-i-zdjecia/obiekt-zalaczniki-i-zdjecia.component';
import { OsPasekCzasuComponent } from './serwis-mapowy/komponenty/boczna-belka/os-pasek-czasu/os-pasek-czasu.component';
import { PasekCzasuComponent } from './serwis-mapowy/komponenty/boczna-belka/pasek-czasu/pasek-czasu.component';
import { WidokPaskaCzasuComponent } from './serwis-mapowy/komponenty/mapa/widok-paska-czasu/widok-paska-czasu.component';
import { mapaWidokReducer } from './stan/mapa-widok/mapa-widok.reducer';
import { NgxSliderModule } from 'ngx-slider-v2';
import { KontaktFormularzComponent } from './commons/komponenty/kontakt-formularz/kontakt-formularz.component';
import { KontaktZAdministratoremDialogComponent } from './serwis-mapowy/komponenty/kontakt/kontakt-z-administratorem-dialog/kontakt-z-administratorem-dialog.component';
import { PomocBelkaBocznaComponent } from './serwis-mapowy/komponenty/pomoc/pomoc-belka-boczna/pomoc-belka-boczna.component';
import { PomocDialogComponent } from './serwis-mapowy/komponenty/pomoc/pomoc-dialog/pomoc-dialog.component';
import { KontaktZAdministratoremBelkaBocznaComponent } from './serwis-mapowy/komponenty/kontakt/kontakt-z-administratorem-belka-boczna/kontakt-z-administratorem-belka-boczna.component';
import { WyszukiwarkaMapowaComponent } from './serwis-mapowy/komponenty/wyszukiwarka/wyszukiwarka-mapowa/wyszukiwarka-mapowa.component';
import { WyszukiwarkaObiektyTabComponent } from './serwis-mapowy/komponenty/wyszukiwarka/obiekty/wyszukiwarka-obiekty-tab/wyszukiwarka-obiekty-tab.component';
import { wyszukiwarkaReducer } from './stan/wyszukiwarka/wyszukiwarka.reducer';
import { WynikiBrakComponent } from './serwis-mapowy/komponenty/wyszukiwarka/wspolne/wyniki-brak/wyniki-brak.component';
import { WynikiObiektyDesktopComponent } from './serwis-mapowy/komponenty/wyszukiwarka/wspolne/wyniki-obiekty-desktop/wyniki-obiekty-desktop.component';
import { WynikiObiektyMobileComponent } from './serwis-mapowy/komponenty/wyszukiwarka/wspolne/wyniki-obiekty-mobile/wyniki-obiekty-mobile.component';
import { WyszukiwarkaObiektyOdlegloscTabComponent } from './serwis-mapowy/komponenty/wyszukiwarka/obiekty-odleglosc/wyszukiwarka-obiekty-odleglosc-tab/wyszukiwarka-obiekty-odleglosc-tab.component';
import { WyszukiwarkaDzialkiTabComponent } from './serwis-mapowy/komponenty/wyszukiwarka/dzialki/wyszukiwarka-dzialki-tab/wyszukiwarka-dzialki-tab.component';
import { WynikiDzialkiDesktopComponent } from './serwis-mapowy/komponenty/wyszukiwarka/dzialki/wyniki-dzialki-desktop/wyniki-dzialki-desktop.component';
import { WynikiDzialkiMobileComponent } from './serwis-mapowy/komponenty/wyszukiwarka/dzialki/wyniki-dzialki-mobile/wyniki-dzialki-mobile.component';
import { WyszukaneObiektyILokalizacjeComponent } from './serwis-mapowy/komponenty/mapa/wyszukane-obiekty-i-lokalizacje/wyszukane-obiekty-i-lokalizacje.component';
import { MatIconModule } from '@angular/material/icon';
import { ObiektTagiComponent } from './serwis-mapowy/komponenty/mapa/obiekt-tagi/obiekt-tagi.component';
import { KontrolerNarzedziPodstawowychComponent } from './serwis-mapowy/komponenty/gorna-belka/kontroler-narzedzi-podstawowych/kontroler-narzedzi-podstawowych.component';
import { UdostepnianieDialogComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnianie-dialog/udostepnianie-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UdostepnijLinkComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnij-link/udostepnij-link.component';
import { UdostepnianieMobilneComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnianie-mobilne/udostepnianie-mobilne.component';
import { UdostepnijKodComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnij-kod/udostepnij-kod.component';
import { UdostepnienieWidokMapyComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnienie-widok-mapy/udostepnienie-widok-mapy.component';
import { MatInputModule } from '@angular/material/input';
import { PodgladMapyComponent } from './serwis-mapowy/strony/podglad-mapy/podglad-mapy.component';
import { UdostepnijLinkPaskaCzasuComponent } from './serwis-mapowy/komponenty/gorna-belka/udostepnij-link-paska-czasu/udostepnij-link-paska-czasu.component';
import { OknoWydrukuMapyComponent } from './serwis-mapowy/komponenty/mapa/okno-wydruku-mapy/okno-wydruku-mapy/okno-wydruku-mapy.component';
import { FormularzWydrukuMapyComponent } from './serwis-mapowy/komponenty/mapa/okno-wydruku-mapy/formularz-wydruku-mapy/formularz-wydruku-mapy.component';
import { WidokMapyWydrukComponent } from './serwis-mapowy/komponenty/mapa/okno-wydruku-mapy/widok-mapy-wydruk/widok-mapy-wydruk.component';
import { PobieranieDanychProviderService } from './serwis-mapowy/serwisy/pobieranie-danych-provider.service';
import { PomocFormularzComponent } from './commons/komponenty/pomoc-formularz/pomoc-formularz.component';
import { PomocSzczegolyComponent } from './commons/komponenty/pomoc-szczegoly/pomoc-szczegoly.component';
import { QrCodeModule } from 'ng-qrcode';
import { MapaInfoCmsComponent } from './strony-cms/strony/mapa-info-cms/mapa-info-cms.component';
import { MatRadioModule } from '@angular/material/radio';
import { OsPorownanieComponent } from './serwis-mapowy/komponenty/boczna-belka/os-porownanie/os-porownanie.component';
import { WidokPorownanieMapyComponent } from './serwis-mapowy/komponenty/mapa/widok-porownanie-mapy/widok-porownanie-mapy.component';
import { createCustomElement } from '@angular/elements';
import { ImageCompareComponent } from './strony-cms/komponenty/image-compare/image-compare.component';
import { PrzyciskProstokatnyComponent } from './commons/komponenty/przycisk-prostokatny/przycisk-prostokatny.component';
import { AutofocusDirective } from './commons/directives/autofocus.directive';
import { DynamicLoaderFromHtmlComponent } from './strony-cms/komponenty/dynamic-loader-from-html/dynamic-loader-from-html.component';
import { KontrolerNarzedziZaawansowanychComponent } from './serwis-mapowy/komponenty/gorna-belka/kontroler-narzedzi-zaawansowanych/kontroler-narzedzi-zaawansowanych.component';
import { NsDokonajPomiaruComponent } from './serwis-mapowy/komponenty/boczna-belka/ns-dokonaj-pomiaru/ns-dokonaj-pomiaru.component';
import { NsPrzejdzDoWspolrzednychComponent } from './serwis-mapowy/komponenty/boczna-belka/ns-przejdz-do-wspolrzednych/ns-przejdz-do-wspolrzednych.component';
import { NwPrzejdzDoWspolrzednychComponent } from './serwis-mapowy/komponenty/mapa/nw-przejdz-do-wspolrzednych/nw-przejdz-do-wspolrzednych.component';
import { narzedziaReducer } from './stan/narzedzia/narzedzia.reducer';
import { NwDokonajPomiaruComponent } from './serwis-mapowy/komponenty/mapa/nw-dokonaj-pomiaru/nw-dokonaj-pomiaru.component';
import { NsDokonajPomiaruDialogComponent } from './serwis-mapowy/komponenty/boczna-belka/ns-dokonaj-pomiaru-dialog/ns-dokonaj-pomiaru-dialog.component';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OverlayModule } from '@angular/cdk/overlay';
import { warstwyDodatkoweReducer } from './stan/warstwy-dodatkowe/warstwy-dodatkowe.reducer';
import { NsSzlakComponent } from './serwis-mapowy/komponenty/boczna-belka/ns-szlak/ns-szlak.component';
import { NwSzlakComponent } from './serwis-mapowy/komponenty/mapa/nw-szlak/nw-szlak.component';
@NgModule({
  declarations: [
    SerwisMapowyComponent,
    PasekStanuComponent,
    SterowanieMapyComponent,
    TylkoDesktopDirective,
    TylkoMobileDirective,
    WidokMapyNarzedziaSekcjaComponent,
    WidokMapyComponent,
    InformacjeOObiekcieComponent,
    KontrolerWarstwPodkladowychComponent,
    WyborTlumaczeniaPipe,
    MapaSpinnerComponent,
    KlikalnoscNaMapieComponent,
    KontrolerFunkcjiDodatkowychComponent,
    MobilnyKontrolerNarzedziComponent,
    BocznaBelkaKontenerComponent,
    OsPrzegladanieComponent,
    OsTematyComponent,
    OsSzlakiComponent,
    OsTagiComponent,
    OsInfoComponent,
    BelkaKartaMapyComponent,
    OsMapyPlanyComponent,
    ObiektOpisComponent,
    LokalizacjaOpisComponent,
    ObiektZalacznikiIZdjeciaComponent,
    OsPasekCzasuComponent,
    PasekCzasuComponent,
    WidokPaskaCzasuComponent,
    KontaktZAdministratoremDialogComponent,
    PomocBelkaBocznaComponent,
    PomocDialogComponent,
    KontaktZAdministratoremBelkaBocznaComponent,
    WyszukiwarkaMapowaComponent,
    WyszukiwarkaObiektyTabComponent,
    WynikiBrakComponent,
    WynikiObiektyDesktopComponent,
    WynikiObiektyMobileComponent,
    WyszukiwarkaObiektyOdlegloscTabComponent,
    WyszukiwarkaDzialkiTabComponent,
    WynikiDzialkiDesktopComponent,
    WynikiDzialkiMobileComponent,
    WyszukaneObiektyILokalizacjeComponent,
    ObiektTagiComponent,
    KontrolerNarzedziPodstawowychComponent,
    UdostepnianieDialogComponent,
    UdostepnijLinkComponent,
    UdostepnianieMobilneComponent,
    UdostepnijKodComponent,
    UdostepnienieWidokMapyComponent,
    PodgladMapyComponent,
    UdostepnijLinkPaskaCzasuComponent,
    OknoWydrukuMapyComponent,
    FormularzWydrukuMapyComponent,
    WidokMapyWydrukComponent,
    MapaInfoCmsComponent,
    OsPorownanieComponent,
    WidokPorownanieMapyComponent,
    ImageCompareComponent,
    DynamicLoaderFromHtmlComponent,
    KontrolerNarzedziZaawansowanychComponent,
    NsDokonajPomiaruComponent,
    NsPrzejdzDoWspolrzednychComponent,
    NwPrzejdzDoWspolrzednychComponent,
    NwDokonajPomiaruComponent,
    NsDokonajPomiaruDialogComponent,
    NsSzlakComponent,
    NwSzlakComponent,

  ],
  imports: [
    QrCodeModule,
    CommonModule,
    CommonsModule,
    FormsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatTooltipModule,
    NgxSliderModule,
    OracleMapsModule,
    OverlayModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MatTabsModule,
    StoreModule.forFeature('modulMapowy', {
      interfejsUzytkownika: interfejsUzytkowikaReducer,
      widoki: lewyPanelWidokReducer,
      widokMapy: mapaWidokReducer,
      wyszukiwarka: wyszukiwarkaReducer,
      narzedzia: narzedziaReducer,
      warstwyDodatkowe: warstwyDodatkoweReducer
    }
    ),
  ],
  exports: [
    AutofocusDirective,
    BelkaKartaMapyComponent,
    SerwisMapowyComponent,
    IkonaSvgDirective,
    KontaktFormularzComponent,
    OracleMapsModule,
    MapaInfoCmsComponent,
    MatLegacySliderModule,
    MatProgressSpinnerModule,
    PrzewijanyKomponentComponent,
    PrzyciskIkonaComponent,
    PrzyciskOkraglyComponent,
    PrzyciskProstokatnyComponent,
    TylkoDesktopDirective,
    TylkoMobileDirective,
    RerenderDirective,
    MatTabsModule,
    PodgladMapyComponent,
    PomocFormularzComponent,
    PomocSzczegolyComponent
  ],
  providers: [
    { provide: TlumaczeiaModulMapowyAdapter, useClass: DomyslnyTlumaczeniaModulMapowyAdapter },
    { provide: DostepneWarstwyModulMapowyAdapter, useClass: DomyslnyDostepneWarstwyAdapter },
    { provide: MapyModulMapowyAdapter, useClass: DomyslneMapyModulMapowyAdapter },
    { provide: GrupyWarstwPodkladowychModulMapowyAdapter, useClass: DomyslneGrupyWarstwPodkladowychAdapter },
    { provide: KomunikatyModulMapowyAdapter, useClass: DomyslneKomunikatyModulMapowyAdapter },
    { provide: KontaktZAdministratoremModulMapowyAdapter, useClass: DomyslnyKontaktZAdministratoremAdapter },
    { provide: KonfiguracjaModulMapowyAdapter, useClass: DomyslnaKonfiguracjaModulMapowyAdapter },
    { provide: WyszukiwarkaModulMapowyAdapter, useClass: DomyslnyWszukiwarkaAdapter },
    { provide: PobieranieDanychModulMapowyAdapter, useClass: PobieranieDanychProviderService },
    { provide: PasekCzasuModulMapowyAdapter, useClass: DomyslnyPasekCzasuModulMapowyAdapter },
    { provide: PomocModulMapowyAdapter, useClass: DomyslnaPomocModulMapowyAdapter },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, hasBackdrop: true } },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ModulMapowyModule {
  constructor(injector: Injector) {
    if (!customElements.get('mm-image-compare')) {
      const el = createCustomElement(ImageCompareComponent, { injector });
      customElements.define('mm-image-compare', el);
    }
  }
}
